export default __webpack_public_path__ + "static/media/video.28d6f006.mp4";